import { createQueryKeyStore } from "@lukemorales/query-key-factory";

export const otcSaleKeys = createQueryKeyStore({
  otcSale: {
    questionnaire: (drugTypeId?: string, ecClientId?: string) => [drugTypeId ?? "", ecClientId ?? ""],
    consent: (screeningId?: string, consentEntryId?: string) => [screeningId ?? "", consentEntryId ?? ""],
    receptionPharmacy: (pharmacyId?: number) => [pharmacyId ?? 0],
    guidanceScreening: (userId?: number, screeningId?: string) => [userId ?? 0, screeningId ?? ""],
  },
});
